module.exports = __webpack_public_path__ + "static/media/tb.4b72ac24.png";